import MapLocation from './MapLocation';

export default MapLocation;
